import { type ComponentType, type SVGProps } from 'react'

import {
    AddToListIcon,
    Button,
    DetailIcon,
    Menu,
    MenuContent,
    MenuItem,
    MenuTrigger,
    PauseIcon,
    PlayIcon,
} from '@ds/components'

import styles from './CollectionActions.module.css'

export type TCollectionActionMenuItem = {
    key: string
    Icon: ComponentType<SVGProps<SVGSVGElement>>
    label: string
    onSelect: () => void
}

export type TCollectionActionsProps = {
    canPlay: boolean
    isPlaying: boolean
    isPlayLoading: boolean
    playLabel: string
    onPlay: () => void
    canModify: boolean
    addRemoveLabel: string
    onAddRemove: () => void
    moreLabel: string
    menuItems: TCollectionActionMenuItem[]
}

export const CollectionActions = ({
    canPlay,
    isPlaying,
    isPlayLoading,
    playLabel,
    onPlay,
    canModify,
    addRemoveLabel,
    onAddRemove,
    moreLabel,
    menuItems,
}: TCollectionActionsProps) => (
    <div className={styles.actions}>
        {canPlay ? (
            <Button
                variant="primary"
                size="small"
                LeftIcon={isPlaying ? PauseIcon : PlayIcon}
                loading={isPlayLoading}
                onClick={onPlay}
            >
                {playLabel}
            </Button>
        ) : null}

        {canModify ? (
            <Button
                variant="secondary"
                size="small"
                LeftIcon={AddToListIcon}
                aria-label={addRemoveLabel}
                data-test="collection-action-add-audio"
                onClick={onAddRemove}
            >
                {addRemoveLabel}
            </Button>
        ) : null}

        <Menu>
            <MenuTrigger asChild>
                <Button
                    variant="secondary"
                    size="small"
                    LeftIcon={DetailIcon}
                    aria-label={moreLabel}
                    data-test="collection-more-actions-button"
                />
            </MenuTrigger>
            <MenuContent>
                {menuItems.map(({ key, Icon, label, onSelect }) => (
                    <MenuItem key={key} onSelect={onSelect} className={styles.item}>
                        <Icon className={styles.icon} />
                        {label}
                    </MenuItem>
                ))}
            </MenuContent>
        </Menu>
    </div>
)
